import { SubmitArticleFeedbackParameters } from './types';

export const validatePostArticleFeedbackParameters = (
  parameters: SubmitArticleFeedbackParameters,
) => {
  const articleId = parameters?.articleId;
  const knowledgeBaseId = parameters?.knowledgeBaseId;
  const rating = parameters?.rating;

  if (!articleId || !knowledgeBaseId || !rating) {
    return new Error(
      'Missing one or more of the required properties: articleId, knowledgeBaseId, and rating',
    );
  }

  return undefined;
};
